import React from 'react';
import { Box, Container, Typography, Grid, Card, CardContent } from '@mui/material';
import { LANDING_CONTAINER_MAX_WIDTH, landingGridSpacing, landingSectionSpacing } from '@/constants/landingLayout';
import { features } from './condominiumProductContent';

export default function CondoFeaturesSection() {
  return (
    <Box id="features" sx={{ ...landingSectionSpacing, bgcolor: 'background.paper' }}>
      <Container maxWidth={LANDING_CONTAINER_MAX_WIDTH}>
        <Typography variant="h4" component="h2" align="center" gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
          Tudo o que precisa acontecer no condomínio, em um só lugar
        </Typography>
        <Typography
          variant="body1"
          align="center"
          color="text.secondary"
          sx={{ mb: 2, maxWidth: '700px', mx: 'auto', fontSize: '1.1rem' }}
        >
          Organize demandas, tarefas, manutenções e solicitações com mais controle e menos dependência do WhatsApp.
        </Typography>
        <Typography variant="body2" align="center" color="text.secondary" sx={{ mb: 6, maxWidth: '600px', mx: 'auto' }}>
          Do registro da solicitação ao acompanhamento da operação, com histórico e inteligência para ajudar na gestão.
        </Typography>
        <Grid container spacing={landingGridSpacing.cards}>
          {features.map((feature, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                elevation={2}
                sx={{
                  height: '100%',
                  transition: 'transform 0.3s, box-shadow 0.3s',
                  '&:hover': {
                    transform: 'translateY(-8px)',
                    boxShadow: 6,
                  },
                }}
              >
                <CardContent sx={{ textAlign: 'center', p: 3 }}>
                  <Box sx={{ mb: 2 }}>{feature.icon}</Box>
                  <Typography variant="h6" component="h3" gutterBottom sx={{ fontWeight: 'bold' }}>
                    {feature.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {feature.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}